function init() {
  /**
   * Ensure that window always has the hasOwnProperty method on it, as
   * older versions of IE do not have this, and we are testing for jQuery presence
   * using it.
   */
  window.hasOwnProperty = function(obj) {
    return !!this[obj];
  };

  /**
   * Prevent errors from calls to console.* from browsers that don't support it.
   */
  if (!window.hasOwnProperty('console')) {
    window.console = {
      assert() {},
      clear() {},
      count() {},
      debug() {},
      dir() {},
      dirxml() {},
      error() {},
      exception() {},
      group() {},
      groupCollapsed() {},
      groupEnd() {},
      info() {},
      log() {},
      profile() {},
      profileEnd() {},
      table() {},
      time() {},
      timeEnd() {},
      timeStamp() {},
      trace() {},
      warn() {},
    };
  }
}

export default {
  init,
};



// WEBPACK FOOTER //
// ../utilities/console.js